import { Box } from "@chakra-ui/react";
import { isEmptyOrNull, isNotEmptyOrNull } from "../../../utils/common-utils";
import CustomAccordionItem from "./CustomAccordionItem";
import { stringConstants } from "../../../utils/strings/StringConstants";

const CustomAssessmentAccordion = ({
  subTopicTaskProgress,
  setTaskType,
  onClick,
  isChapterEndAssessment,
}) => {
  if (isEmptyOrNull(subTopicTaskProgress)) {
    return (
      <Box>
        {stringConstants?.accordionStrings?.defaultCustomAssessmentText}
      </Box>
    );
  }

  return subTopicTaskProgress
    ?.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
    ?.map((item, index) => {
      if (isNotEmptyOrNull(item)) {
        return (
          <CustomAccordionItem
            key={index}
            item={item}
            index={index}
            setTaskType={setTaskType}
            onClick={onClick}
            isChapterEndAssessment={isChapterEndAssessment}
          />
        );
      }
      return null;
    });
};

export default CustomAssessmentAccordion;
